<div [ngSwitch]="item.tipo" class="d-flex align-items-center" [formGroup]="parametros">

    <mat-form-field *ngSwitchCase="'TEXTO'" class="small-input" appearance="outline">
      <mat-label *ngIf="item.obrigatorio">&nbsp;</mat-label>
      <input matInput type="text" [formControlName]="item.variavel" maxlength="150" [required]="item.obrigatorio">
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'INTEIRO'" class="small-input" appearance="outline">
      <mat-label *ngIf="item.obrigatorio">&nbsp;</mat-label>
      <input matInput digitOnly type="text" [formControlName]="item.variavel" maxlength="150" [required]="item.obrigatorio">
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'PERCENTUAL'" class="small-input" appearance="outline">
      <mat-label *ngIf="item.obrigatorio">{{ item.label }}</mat-label>
      <mat-label *ngIf="isParametrosPaiObrigatorio && !isConsulta">{{ item.label }} *</mat-label>
      <mat-label *ngIf="isParametrosPaiObrigatorio && isConsulta">{{ item.label }}</mat-label>
      <input matInput digitOnly [decimal]="true" type="text" currencyMask [options]="{precision:2}"
           [formControlName]="item.variavel" maxlength="6" [required]="item.obrigatorio">
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'VALOR_FINANCEIRO'" class="small-input" appearance="outline">
      <mat-label *ngIf="item.obrigatorio">{{ item.label }}</mat-label>
      <mat-label *ngIf="isParametrosPaiObrigatorio && !isConsulta">{{ item.label }} *</mat-label>
      <mat-label *ngIf="isParametrosPaiObrigatorio && isConsulta">{{ item.label }}</mat-label>
      <input matInput digitOnly [decimal]="true" type="text" currencyMask [options]="{precision:2}"
      [formControlName]="item.variavel" maxlength="150" [required]="item.obrigatorio">
    </mat-form-field>

  <mat-slide-toggle *ngSwitchCase="'BOOLEAN'"
    color="primary"
    [formControlName]="item.variavel"
    required="false"
    [checked]="itemValue"
    class="switch switch-medium">
  </mat-slide-toggle>

  <div *ngSwitchCase="'SELECT'"  style="width: 100%;">
    <mat-form-field class="select-field" appearance="outline">
      <mat-label *ngIf="item.obrigatorio">&nbsp;</mat-label>
      <mat-select [formControlName]="item.variavel" [required]="item.obrigatorio">
        <mat-option *ngIf="!item.obrigatorio" value=""></mat-option>
        <mat-option *ngFor="let opcao of opcoes" [value]="opcao.key">{{opcao.displayName}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="'MULTI_SELECT'" [ngSwitch]="item.variavel" class="w-100">
    <app-autocomplete-multiselect
      [parametroFuncaoSchema]="item"
      [value]="itemValue"
      [readonly]="isConsulta"
      [formGroup]="parentForm"
    ></app-autocomplete-multiselect>
  </div>

  <div *ngSwitchCase="'CHECKBOX'">
    <maps-checkbox
        [schema]="item"
        [formGroup]="parametros"
        [readonly]="isConsulta"
        [parametrosRegra]="parametrosRegra"
    ></maps-checkbox>
  </div>

  <div *ngSwitchCase="'COMPOSTO'" class="row w-100">
    <app-parametro-funcao-composto
      [schema]="item"
      [formGroup]="parametros"
      [parentGroup]="parentForm"
      [value]="itemValue"
      [readonly]="isConsulta"
      [parametrosRegra]="parametrosRegra" class="w-100">
    </app-parametro-funcao-composto>
  </div>
</div>

